import React from "react";
import { useHistory, useParams, useLocation } from "react-router-dom";

import { Context, fetchActiveLearningLesson } from "../../../teacherStore";
import { parseQueryParams } from "../../../libs/Util";
import ActiveLearningProjection from "../../../templates/teacher/ActiveLearningProjection";

export default () => {
  const lessonParam = parseInt(parseQueryParams()["lesson"]);
  const { state, dispatch } = React.useContext(Context);
  const history = useHistory();
  const { id } = useParams();
  const location = useLocation();
  const params = React.useMemo(() => new URLSearchParams(location.search), [
    location.search,
  ]);

  // if (lessonParam) {
  //   history.push(notFoundPath);
  //   return null;
  // }

  React.useEffect(() => {
    dispatch(fetchActiveLearningLesson(lessonParam, id, true));
  }, [dispatch, lessonParam, id]);

  const lesson = React.useMemo(
    () =>
      state.activeLearningLesson &&
      state.activeLearningLesson.id === lessonParam
        ? state.activeLearningLesson
        : null,
    [lessonParam, state.activeLearningLesson],
  );

  const handleChangeLesson = React.useCallback(
    (lessonId: number) => {
      const nextParams = new URLSearchParams(params);
      nextParams.set("lesson", String(lessonId));
      nextParams.set("page", "1");

      history.push({
        search: `?${nextParams.toString()}`,
      });
    },
    [history, params],
  );

  return (
    <ActiveLearningProjection
      lesson={lesson}
      prevLessonId={state.prev_lesson_id}
      nextLessonId={state.next_lesson_id}
      onChangeLesson={handleChangeLesson}
    />
  );
};
